import { useEvents } from "../hooks/useEvents.js";
import "react";
import { Skeleton } from "@therms/atalaya";
import { Fragment as Fragment$1, jsx, jsxs } from "react/jsx-runtime";
//#region src/modules/Events/shared/EventNames.tsx
var EventNames = ({ eventIds, listAll = true }) => {
	const { data, loading } = useEvents({ idFilter: eventIds }, { cacheStrategy: "cache-only" });
	if (!data?.events && loading) return /* @__PURE__ */ jsx(Skeleton.Text, { chars: 25 });
	if (!data?.events || !eventIds?.length) return null;
	if (!listAll && data.total > 1) return /* @__PURE__ */ jsxs("div", {
		className: "flex min-w-0 shrink flex-nowrap",
		children: [/* @__PURE__ */ jsx("div", {
			className: "truncate",
			children: data.events[0].title
		}), /* @__PURE__ */ jsxs("span", {
			className: "text-info pl-xxs min-w-fit flex-1",
			children: ["+", data.total - 1]
		})]
	});
	return /* @__PURE__ */ jsx(Fragment$1, { children: data.events.map(({ title }) => title).join(", ") });
};
//#endregion
export { EventNames };

//# sourceMappingURL=EventNames.js.map